import { render, staticRenderFns } from "./qrcodeRegister.vue?vue&type=template&id=236947ac&scoped=true&"
import script from "./qrcodeRegister.vue?vue&type=script&lang=js&"
export * from "./qrcodeRegister.vue?vue&type=script&lang=js&"
import style0 from "./qrcodeRegister.vue?vue&type=style&index=0&id=236947ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236947ac",
  null
  
)

export default component.exports